(function () {
    'use strict';

    angular.module('imApp').factory('orderPickNewService', [
        '$ihttp',
        function ($ihttp) {
            let service = {
                getSetting: function (parms) {
                    return $ihttp.post({
                        method: 3700,
                        parameters: parms || {},
                    });
                },
                changeProductId: function (setting) {
                    return $ihttp.post({
                        method: 3701,
                        parameters: setting,
                    });
                },
                recalcQuantityStockUnits: function (setting) {
                    return $ihttp.post({
                        method: 3703,
                        parameters: setting,
                    });
                },
                saveObj: function (mergeObj) {
                    return $ihttp.post({
                        method: 3704,
                        parameters: mergeObj,
                    });
                },
                distributeObj: function (mergeObj) {
                    return $ihttp.post({
                        method: 3705,
                        parameters: mergeObj,
                    });
                },
                orderlines: function (params) {
                    return $ihttp.post({ method: 3925, parameters: params });
                },
            };

            return service;
        },
    ]);
})();
